var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "69px",
    height: "71px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M -0.5,-0.5 C 22.5,-0.5 45.5,-0.5 68.5,-0.5C 68.5,23.1667 68.5,46.8333 68.5,70.5C 45.5,70.5 22.5,70.5 -0.5,70.5C -0.5,46.8333 -0.5,23.1667 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#383838",
    d: "M 27.5,4.5 C 30.8333,4.5 34.1667,4.5 37.5,4.5C 37.5,6.5 37.5,8.5 37.5,10.5C 34.1667,10.5 30.8333,10.5 27.5,10.5C 27.5,8.5 27.5,6.5 27.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dddddd",
    d: "M 37.5,4.5 C 38.7564,4.90384 39.9231,5.57051 41,6.5C 47.1278,5.39487 53.2944,5.2282 59.5,6C 61.0488,7.21398 62.2155,8.71398 63,10.5C 64.1069,19.2754 64.6069,28.1087 64.5,37C 64.4997,44.6743 64.1664,52.1743 63.5,59.5C 63.5,46.5 63.5,33.5 63.5,20.5C 53.2006,21.5937 42.8672,21.7603 32.5,21C 30.9391,20.6824 29.7724,19.8491 29,18.5C 28.5034,16.1902 28.3367,13.8568 28.5,11.5C 31.7131,11.81 34.7131,11.4767 37.5,10.5C 37.5,8.5 37.5,6.5 37.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0d2ce",
    d: "M 26.5,4.5 C 26.5,8.83333 26.5,13.1667 26.5,17.5C 19.5,17.5 12.5,17.5 5.5,17.5C 5.58645,13.1434 5.91979,8.81002 6.5,4.5C 9.83333,4.5 13.1667,4.5 16.5,4.5C 16.238,5.97782 16.5713,7.31116 17.5,8.5C 18.9814,7.51968 20.3147,6.35301 21.5,5C 23.1341,4.50649 24.8008,4.33982 26.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdcccc",
    d: "M 26.5,4.5 C 26.8333,4.5 27.1667,4.5 27.5,4.5C 27.5,6.5 27.5,8.5 27.5,10.5C 30.8333,10.5 34.1667,10.5 37.5,10.5C 34.7131,11.4767 31.7131,11.81 28.5,11.5C 28.3367,13.8568 28.5034,16.1902 29,18.5C 29.7724,19.8491 30.9391,20.6824 32.5,21C 42.8672,21.7603 53.2006,21.5937 63.5,20.5C 63.5,33.5 63.5,46.5 63.5,59.5C 63.9368,62.8066 63.2702,65.8066 61.5,68.5C 43.5093,69.6663 25.5093,69.833 7.5,69C 5.06952,66.6954 4.06952,63.8621 4.5,60.5C 5.5,61.1667 6.5,61.8333 7.5,62.5C 12.3054,63.4872 17.3054,63.8205 22.5,63.5C 29.0308,64.7781 35.5308,64.7781 42,63.5C 42.6667,57.5 42.6667,51.5 42,45.5C 41.7216,44.5842 41.2216,43.9175 40.5,43.5C 39.0632,39.1704 37.0632,35.1704 34.5,31.5C 34.5,29.5 34.5,27.5 34.5,25.5C 31.8333,25.5 29.1667,25.5 26.5,25.5C 26.5,23.1667 26.5,20.8333 26.5,18.5C 26.5,18.1667 26.5,17.8333 26.5,17.5C 26.5,13.1667 26.5,8.83333 26.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#343130",
    d: "M 34.5,31.5 C 37.0632,35.1704 39.0632,39.1704 40.5,43.5C 41.2216,43.9175 41.7216,44.5842 42,45.5C 42.6667,51.5 42.6667,57.5 42,63.5C 35.5308,64.7781 29.0308,64.7781 22.5,63.5C 22.3335,53.4944 22.5002,43.4944 23,33.5C 23.5,33 24,32.5 24.5,32C 27.8168,31.5017 31.1501,31.335 34.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6787c",
    d: "M 5.5,17.5 C 12.5,17.5 19.5,17.5 26.5,17.5C 26.5,17.8333 26.5,18.1667 26.5,18.5C 19.5,18.5 12.5,18.5 5.5,18.5C 5.0095,33.2635 5.67616,47.9302 7.5,62.5C 6.5,61.8333 5.5,61.1667 4.5,60.5C 4.17075,45.9903 4.50408,31.6569 5.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eb0518",
    d: "M 26.5,18.5 C 26.5,20.8333 26.5,23.1667 26.5,25.5C 29.1667,25.5 31.8333,25.5 34.5,25.5C 34.5,27.5 34.5,29.5 34.5,31.5C 31.1501,31.335 27.8168,31.5017 24.5,32C 24,32.5 23.5,33 23,33.5C 22.5002,43.4944 22.3335,53.4944 22.5,63.5C 17.3054,63.8205 12.3054,63.4872 7.5,62.5C 5.67616,47.9302 5.0095,33.2635 5.5,18.5C 12.5,18.5 19.5,18.5 26.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f70801",
    d: "M 40.5,43.5 C 41.2197,49.1377 41.553,54.8044 41.5,60.5C 35.8333,60.5 30.1667,60.5 24.5,60.5C 24.653,54.1308 24.3197,47.7974 23.5,41.5C 29.4632,40.9546 35.1299,41.6213 40.5,43.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOil);
export default __webpack_public_path__ + "static/media/oil.28de63460171af2fa26cb8361fc476dd.svg";
export { ForwardRef as ReactComponent };